import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import { Form, Formik, useFormikContext } from 'formik'
import { interfaces } from 'service/interfaces'
import * as yup from 'yup'

import ClientSearchAutocomplete from './ClientSearchAutocomplete'

const CreateFormPaymentOrders = ({
  enteprises,
  formikRef,
  loading,
  onClose,
  render,
  setLoading,
  setRender,
}) => {
  const fields = (values, setFieldValue, showClientError, clientErrorText) => [
    {
      class: 'autocomplete',
      sm: 12,
      xs: 12,
      name: 'origen',
      label: 'Origen',
      optionValue: 'id',
      options: enteprises,
      optionLabel: `options["label"]`,
      value: values?.origen,
      disabled: loading,
      sortBy: 'label',
      onChange: (value) => {
        setFieldValue('origen', value?.id || '')
        if (values?.clienteId) {
          setFieldValue('clienteId', '')
        }
      },
    },
    {
      class: 'custom',
      sm: 12,
      xs: 12,
      component: (
        <ClientSearchAutocomplete
          origen={values?.origen}
          valueId={values?.clienteId}
          onSelectId={(id) => setFieldValue('clienteId', id)}
          disabled={loading}
          label="Cliente"
          error={showClientError}
          helperText={showClientError ? clientErrorText : ''}
        />
      ),
    },
  ]

  const FormContent = () => {
    const { setFieldValue, submitCount, values } = useFormikContext()
    const showClientError = Boolean(!loading && submitCount > 0 && !values?.clienteId)

    return (
      <Form>
        <InputsWithValidate
          fields={fields(values, setFieldValue, showClientError, 'Cliente obligatorio')}
          spacing={2}
          setFieldValue={setFieldValue}
        />
      </Form>
    )
  }

  const validationSchema = yup.object().shape({
    origen: yup.number().required('Origen obligatorio').typeError('Origen obligatorio'),
    clienteId: yup.number().required('Cliente obligatorio').typeError('Cliente obligatorio'),
  })

  const onSubmit = async (values) => {
    const clienteId = values?.clienteId || null
    const empresa = values?.origen || null

    setLoading(true)

    const body = {
      empresa: Number(empresa),
      cliente_id: Number(clienteId),
    }

    try {
      await interfaces.salesPaymentOrders.create(body)
      onClose()
      setRender(!render)
    } catch (e) {
      // error handled by parent/loading flow
    } finally {
      setLoading(false)
    }
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        origen: 1,
        clienteId: '',
      }}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      validateOnSubmit={true}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <FormContent />
    </Formik>
  )
}

export default CreateFormPaymentOrders
